import { yupResolver } from "@hookform/resolvers/yup";
import { makeStyles } from "@mui/styles";
import _, { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DateFns from "src/utils/DateFns";
import * as yup from "yup";
import { QueryInquiryBill } from "../../../../api/queryInquiryBill";
import ButtonCommon from "../../../../commonStyles/button/button";
import {
  date,
  ivalidDate,
  limitDate,
  currentYear,
} from "../../../../const/date";
import { messageQueryError, VALIDATE_MESSAGE } from "../../../../const/message";
import { useCheckLoading } from "../../../../providers/checkLoadingProvider";
import ContractInsurance from "../../../contractInsurance/contractInsurance";
import DontHasResult from "../../../dontHasResult/dontHasResult";
import ControllerTextField from "../../../Form/ControllerTextField";
import DatePickerCustom from "../../../Form/datePickerCustom";
import FormLabel from "../../../Form/FormLabel";
import RecaptchaGoogle from "../recaptchaGoogle/recaptchapGoogle";
import { DATE_FORMATS, textButton } from "../../../../const/index";
import { fieldNameInput } from "../../../../const/fieldInput";
import { DateUtils } from "src/utils/DateUtils";

const useStyles = makeStyles((theme) => {
  return {
    containerBtn: {
      ...theme.custom.flexBox.flexJusCenter,
      paddingBottom: "16px",
      [theme.breakpoints.down("md")]: {
        paddingBottom: "28px",
      },
    },
    containerForm: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "16px",
      [theme.breakpoints.down("md")]: {
        display: "block",
        marginBottom: "32px",
      },
    },
    containerRecaptcha: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "16px",
    },
    dateField: {
      width: "49%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    mb16: {
      marginBottom: "16px",
    },
  };
});
interface IForm {
  insuranceContractNumber: string;
  bornPeopleBuyInsurance: string;
  bornPeopleUseInsurance: string;
}

interface IProps { }
interface IParams {
  frSystm?: string;
  contractNumber?: string;
  bornPeopleBuy?: string;
  bornPeopleUse?: string;
  [key: string]: any;
}
const QueryInsuranceNumber = (props: IProps) => {
  const params: IParams = Object.fromEntries(
    new URLSearchParams(location.search.split("?")[1])
  );
  const [dataContract, setDataContract] = React.useState<any>();
  const [isShowContract, setIsShowContract] = React.useState(false);
  const [heightBtnDate, setHeightBtnDate] = React.useState<number>();
  const [valueRecaptcha, setValueRecaptcha] = React.useState<string>("");
  const [firtsView, setFirtsView] = React.useState<boolean>(false);
  const [hideCaptcha, setHideCaptcha] = React.useState<boolean>();
  const [messageQueryText, setMessageQueryText] = React.useState<string>("");
  const [firstQuery, setFirstQuery] = React.useState(false);
  const refRecaptcha = React.useRef<any>();
  const { setIsLoading } = useCheckLoading();
  const classes = useStyles();
  const { t } = useTranslation();
  console.log("params", params)
  const validationSchema = yup.object().shape({
    insuranceContractNumber: yup
      .string()
      .nullable()
      .default("")
      .required(VALIDATE_MESSAGE.REQUIRED("")),
    bornPeopleBuyInsurance: yup
      .string()
      .nullable()
      .default(null)
      .required(VALIDATE_MESSAGE.REQUIRED(""))
      //! Validate
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          return value !== ivalidDate.validdob;
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,
        (value) => {
          const dateValue = new Date(value);
          return `${dateValue}` === ivalidDate.ivalidDate
            ? value?.length > 14
            : true;
        }
      )

      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.DAYSLESSTHAN31,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[2]);
            return day < 32;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.MONTHSLESSTHAN12,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[1]);
            return day <= 12;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[2]);
            return day !== 0;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const month = Number(convertResult[1]);
            return month !== 0;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.YEAR,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const year = Number(convertResult[0]);
            return year <= 1899 || year > currentYear ? false : true;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[2]);
            return day < 29 && day > 32;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,
        (value) => {
          const convertDate = new Date(value);
          if (`${convertDate}` !== ivalidDate.ivalidDate) {
            const valueDate = DateFns?.formatDateTime(new Date(value));
            const convertResult = valueDate.replaceAll("/", ",").split(",");
            return `${convertResult[2]}`.startsWith("0")
              ? true
              : new Date(date.minDate) <= new Date(value);
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,
        (value) => {
          const convertDate = new Date(value);
          if (`${convertDate}` !== ivalidDate.ivalidDate) {
            const valueDate = DateFns?.formatDateTime(new Date(value));
            const convertResult = valueDate.replaceAll("/", ",").split(",");
            return `${convertResult[2]}`.startsWith("0")
              ? true
              : new Date(date.maxDate) > new Date(value);
          } else {
            return true;
          }
        }
      ),
    bornPeopleUseInsurance: yup
      .string()
      .nullable()
      .default(null)
      .required(VALIDATE_MESSAGE.REQUIRED(""))
      //! Validate
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          return value !== ivalidDate.validdob;
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,
        (value) => {
          const dateValue = new Date(value);
          return `${dateValue}` === ivalidDate.ivalidDate
            ? value?.length > 14
            : true;
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.DAYSLESSTHAN31,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[2]);
            return day < 32;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.MONTHSLESSTHAN12,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[1]);
            return day <= 12;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[2]);
            return day !== 0;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const month = Number(convertResult[1]);
            return month !== 0;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.YEAR,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const year = Number(convertResult[0]);
            return year <= 1899 || year > currentYear ? false : true;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[2]);
            return day < 29 && day > 32;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,
        (value) => {
          const convertDate = new Date(value);
          if (`${convertDate}` !== ivalidDate.ivalidDate) {
            const valueDate = DateFns?.formatDateTime(new Date(value));
            const convertResult = valueDate.replaceAll("/", ",").split(",");
            return `${convertResult[2]}`.startsWith("0")
              ? true
              : new Date(date.minDate) <= new Date(value);
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,
        (value) => {
          const convertDate = new Date(value);
          if (`${convertDate}` !== ivalidDate.ivalidDate) {
            const valueDate = DateFns?.formatDateTime(new Date(value));
            const convertResult = valueDate.replaceAll("/", ",").split(",");
            return `${convertResult[2]}`.startsWith("0")
              ? true
              : new Date(date.maxDate) > new Date(value);
          } else {
            return true;
          }
        }
      ),
  });
  const { control, handleSubmit, reset, formState, setValue, watch } =
    useForm<IForm>({
      mode: "all",
      resolver: yupResolver(validationSchema),
      defaultValues: params && params.contractNumber ? {
        insuranceContractNumber: params.contractNumber,
        bornPeopleBuyInsurance: DateUtils.formatDate(DateUtils.covertToDate(params.bornPeopleBuy, "YYYYMMDD"), DATE_FORMATS.YEAR_MONTH_DATE) ,
        bornPeopleUseInsurance: DateUtils.formatDate(DateUtils.covertToDate(params.bornPeopleUse, "YYYYMMDD"), DATE_FORMATS.YEAR_MONTH_DATE)
      } : validationSchema.getDefault(),
    });
  const callFalse = (res) => {
    setDataContract({});
    if (res.data.msgSts.code === "400") {
      refRecaptcha.current?.reset();
      setMessageQueryText("")


    } else {
      setMessageQueryText(messageQueryError[`msg${res.data.msgSts.code}`]);
    }
  };
  const querySuccess = (res) => {
    setDataContract(res.data);
    // setFirstQuery(true);
  };
  const callQueryContrac = async (data) => {
    setIsLoading(true);
    try {
      const res = await QueryInquiryBill(data, valueRecaptcha, params?.frSystm);
      res.data.msgSts.code === "000" ? querySuccess(res) : callFalse(res);
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
      const codeNumber = "007";
      setMessageQueryText(messageQueryError[`msg${codeNumber}`]);
    } finally {
      setIsLoading(false);
      setIsShowContract(true);
      setFirstQuery(true);
    }
  };
  const allValueForm = (data: IForm) => {
    valueRecaptcha ? callQueryContrac(data) : null;
  };
  useEffect(() => {
    const elementInput = document.getElementById(
      fieldNameInput.bornPeopleBuyInsurance
    );
    const heightInput = elementInput?.clientHeight;
    setHeightBtnDate(heightInput + 1);
  }, []);
  const checkValueRecapcha = (token: string) => {
    setValueRecaptcha(token);
  };
  const clickQuery = () => {
    valueRecaptcha ? setFirtsView(false) : setFirtsView(true);
  };
  const resetCaptcha = () => {
    if (firstQuery) {
      refRecaptcha.current?.reset();
      setFirstQuery(false);
    }
  };

  useEffect(() => {
    resetCaptcha();
    setDataContract({});
    setMessageQueryText("");
  }, [
    watch("bornPeopleBuyInsurance"),
    watch("bornPeopleUseInsurance"),
    watch("insuranceContractNumber"),
  ]);



  return (
    <div>
      <ControllerTextField
        control={control}
        name={fieldNameInput.insuranceContractNumber}
        title={t(fieldNameInput.insuranceContractNumber)}
        placeholder={t("enterInsuranceContractNumber")}
        required
        error={!_.isEmpty(formState.errors.insuranceContractNumber)}
        style={{ marginBottom: "16px" }}
        onChange={(e) => {
          const convertValue =
            e.target.value.length > 20
              ? e.target.value.trim().slice(0, 20)
              : e.target.value.trim();
          setValue(fieldNameInput.insuranceContractNumber, convertValue);
        }}
      />
      <div className={classes.containerForm}>
        <div className={`${classes.dateField} ${classes.mb16}`}>
          <FormLabel
            title={t(fieldNameInput.bornPeopleBuyInsurance)}
            name={fieldNameInput.bornPeopleBuyInsurance}
            required
          />
          <DatePickerCustom
            control={control}
            name={fieldNameInput.bornPeopleBuyInsurance}
            error={!_.isEmpty(formState.errors.bornPeopleBuyInsurance)}
            heightInput={heightBtnDate}
            maxDate={new Date()}
          />
        </div>
        <div className={classes.dateField}>
          <FormLabel
            title={t(fieldNameInput.bornPeopleUseInsurance)}
            name={fieldNameInput.bornPeopleUseInsurance}
            required
          />
          <DatePickerCustom
            control={control}
            name={fieldNameInput.bornPeopleUseInsurance}
            error={!_.isEmpty(formState.errors.bornPeopleUseInsurance)}
            heightInput={heightBtnDate}
            maxDate={new Date()}
          />
        </div>
      </div>
      {hideCaptcha === false ? (
        <></>
      ) : (
        <div className={classes.containerRecaptcha}>
          <RecaptchaGoogle
            checkValueRecapcha={checkValueRecapcha}
            isValueCaptcha={valueRecaptcha ? false : true}
            firtsView={firtsView}
            ref={refRecaptcha}
          />
        </div>
      )}
      <div className={classes.containerBtn} onClick={clickQuery}>
        <ButtonCommon onEvent={handleSubmit((data) => allValueForm(data))}>
          {textButton.query}
        </ButtonCommon>
      </div>
      {isShowContract && valueRecaptcha ? (
        !isEmpty(dataContract) ? (
          <ContractInsurance data={dataContract} />
        ) : (
          <>
            {messageQueryText && (
              <DontHasResult textMessage={messageQueryText} />
            )}
          </>
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default QueryInsuranceNumber;
